import React from 'react'
import ReportGenerationFilters from './ReportGenerationFilters'
import { Button, Col, Container, Navbar, Row } from 'reactstrap'
import Layout from 'HorizontalMenu/Menu'
import { RootState } from 'index'
import { useSelector } from 'react-redux'
import apiGlobal from 'global/api.global'
import fileDownload from 'js-file-download'

const PreConfiguredReport = () => {
    /** State variables start */
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    /** State variables end */

    return (
        <>
            <Layout children={Navbar} />
            <div className="page-content">
                <Container fluid>
                    <Row className='mb-3'>
                        <h4>Pre-configured Report Generation</h4>
                    </Row>
                    <ReportGenerationFilters />
                    {VesselID > 0 &&
                        <Row className=''>
                            <Col sm={4}>
                                <strong className='mb-0'>Click here to download the report</strong><br />
                                <Button
                                    type="button"
                                    className="btn btn-primary waves-effect btn-label waves-light"
                                    color='primary'
                                    onClick={() => {
                                        apiGlobal.get(`generate_excel/${VesselID}`, {
                                            responseType: 'blob',
                                        })
                                            .then((res: any) => {
                                                fileDownload(res.data, `Daily-Reporting-${VesselID}.xlsx`)
                                            })
                                    }}
                                >
                                    <i className="mdi mdi-download label-icon"></i>Download
                                </Button>
                            </Col>
                        </Row>
                    }
                </Container>
            </div>
        </>
    )
}

export default PreConfiguredReport